import './css/admin_event_gallery.css';
import React, { useState, useRef, useEffect, Fragment } from 'react';
import axios from 'axios';

//plugins
import InfinityEncryptor from '../../components/EncryptDecrypt/InfinityEncryptor';

//muis
import SearchIcon from '@mui/icons-material/Search'
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

//classes
import Event from '../../i-classes/event.tsx';
import EventItem from '../../i-classes/eventItem.tsx';
class Position {
    public x: number = 0;
    public y: number = 0;
}

const nonstate = {
    s3cr3t: 'ppkm_14082024_mobile',
    eventControlUrl: 'https://www.ppkm.org.my/mobile_backend/scripts/eventControl.php',
    eventItemControlUrl: 'https://www.ppkm.org.my/mobile_backend/scripts/eventItemControl.php'
};

interface Props {

}

const AdminEventGallery: React.FC<Props> = ({ }) => {
    //states
    const [newSearchTerm, SetNewSearchTerm] = useState('');
    const [searchedEventList, SetSearchedEventList] = useState<Event[]>([] as Event[]);
    const [selectedEvent, SetSelectedEvent] = useState<Event | null>(null);
    const [eventItem, SetEventItem] = useState<EventItem | null>(null);
    const [selectedImagesIndex, SetSelectedImagesIndex] = useState<number[]>([]);
    const [shouldRefetchEventItem, SetShouldRefetchEventItem] = useState<boolean>(true);
    const [shouldShowWaitScreen, SetShouldShowWaitScreen] = useState<boolean>(false);
    //states - for item drag drop anim
    const [holdingItem, SetHoldingItem] = useState<string>('');
    const [shadowPos, SetShadowPos] = useState<Position>({ x: 0, y: 0 } as Position);
    const [attemptToMoveItemToIndex, SetAttemptToMoveItemToIndex] = useState<number | null>(null);
    //refs objs
    const searchInRef = useRef<any>(null);
    const eventItemRef = useRef<EventItem | null>(null);
    const optionFileSelectorRef = useRef<any>(null);
    //refs - objs - drag & drop anim
    const holdingItemRef = useRef<string>(holdingItem);
    const holdingItemContainerRef = useRef<any>(null);
    const attemptToMoveItemToIndexRef = useRef<number | null>(attemptToMoveItemToIndex);
    //refs vars
    const selectedImagesIndexRef = useRef<number[]>([]);
    const shouldAddItemCountRef = useRef<number>(0);
    const prevSelectedEventRef = useRef<Event | null>(null);
    //refs actions
    const mouseMoveActionRef = useRef<any>((e: any) => {
        // holdingItemContainerRef.current.style.top = e.clientY;
        // holdingItemContainerRef.current.style.top = e.clientX;

        SetShadowPos({ x: e.clientX, y: e.clientY } as Position);
    });
    const mouseUpActionRef = useRef<any>(() => {
        if (
            attemptToMoveItemToIndexRef.current != null
        ) {
            // eslint-disable-next-line no-restricted-globals
            if (confirm('Are you sure you want to move the item here?')) {
                if (attemptToMoveItemToIndexRef.current != null)
                    MoveItemIndex(holdingItemRef.current, attemptToMoveItemToIndexRef.current);
            }
        }

        //reset everything
        holdingItemRef.current = '';
        SetHoldingItem(holdingItemRef.current);

        attemptToMoveItemToIndexRef.current = null;
        SetAttemptToMoveItemToIndex(attemptToMoveItemToIndexRef.current);
        document.removeEventListener('mouseup', mouseUpActionRef.current);
    });
    //plugins
    const Encryptor = new InfinityEncryptor('22499', 'MYDIH');

    //watchers
    //watch for newSearchTerm update, fetch searchedEventList
    useEffect(() => {
        if (newSearchTerm != '') {
            const formData = new FormData();
            formData.append('s3cr3t', Encryptor.Encrypt(nonstate.s3cr3t));
            formData.append('fetchEventsBySearchString', Encryptor.Encrypt('true'));
            formData.append('searchString', Encryptor.Encrypt(newSearchTerm));

            axios.post(nonstate.eventControlUrl, formData, { withCredentials: false }).then((res: any) => {
                const resData = Encryptor.Decrypt(res.data.toString());

                if (!JSON.stringify(resData).includes('_false')) {
                    const resObjs = JSON.parse(resData) as any[];
                    const events = [] as Event[];

                    resObjs.map((obj: any) => {
                        {
                            events.push(new Event(
                                obj['eventID'],
                                obj['event_categoryID'],
                                obj['event_name'],
                                obj['event_name_highlight_texts'],
                                obj['event_name_highlight_colors'],
                                obj['event_desc'],
                                obj['event_poster'],
                                obj['event_file'],
                                obj['event_venue'],
                                obj['registration_start_date'],
                                obj['registration_end_date'],
                                obj['early_bird_start_date'],
                                obj['early_bird_end_date'],
                                obj['event_start_date'],
                                obj['event_end_date'],
                                obj['event_schedules'],
                                obj['max_pax'],
                                obj['hostID'],
                                obj['datetime_created'],
                                obj['datetime_updated']
                            ));
                        }
                    });
                    SetSearchedEventList([...events]);
                } else {
                    console.log('fetchEventsBySearchStringErr: ' + JSON.stringify(res.data));
                }
            }).catch((err: string) => {
                console.log('fetchEventsBySearchStringErr: ' + err);
            });
        }
    }, [newSearchTerm]);

    //watch for selectedEvent update, fetch selectedEventItem
    useEffect(() => {
        if (
            selectedEvent != null
            && (
                JSON.stringify(prevSelectedEventRef.current) != JSON.stringify(selectedEvent)
                ||
                shouldRefetchEventItem
            )) {
            //update searchinValue
            SetNewSearchTerm(selectedEvent.event_name);

            //clear search event list
            setTimeout(() => {
                SetSearchedEventList([...[]]);
            }, 250);

            const formData = new FormData();
            formData.append('s3cr3t', Encryptor.Encrypt(nonstate.s3cr3t));
            formData.append('fetchEventItemByEventIDAndType', Encryptor.Encrypt('true'));
            formData.append('eventID', Encryptor.Encrypt(selectedEvent.eventID));
            formData.append('type', Encryptor.Encrypt(selectedEvent.eventID));

            axios.post(nonstate.eventControlUrl, formData, { withCredentials: false }).then((res: any) => {
                const resData = Encryptor.Decrypt(res.data.toString());

                if (!JSON.stringify(resData).includes('_false')) {
                    let resObj = JSON.parse(resData) as any;
                    if (Object.keys(resObj).length > 0) {
                        eventItemRef.current = new EventItem(
                            resObj['itemID'],
                            resObj['eventID'],
                            resObj['base_url'],
                            resObj['file_names'],
                            resObj['datetime_expired'],
                            resObj['type']
                        );
                    } else {
                        //no eventItem found
                        console.log('fetchEventItemByEventIDAndTypeErr: EventItemNotFound');
                        //generate a new empty eventItem
                        eventItemRef.current = new EventItem(
                            '',
                            selectedEvent.eventID,
                            '',
                            '',
                            '',
                            '0'
                        );
                    }
                    SetEventItem(eventItemRef.current);
                } else {
                    console.log('fetchEventItemByEventIDAndTypeErr: ' + JSON.stringify(res.data));
                }
            }).catch((err: string) => {
                console.log('fetchEventsBySearchStringErr: ' + err);
            });

            SetShouldRefetchEventItem(false);
        }

        prevSelectedEventRef.current = selectedEvent;
    }, [selectedEvent, shouldRefetchEventItem]);

    //watch for holdingItem create shadowItem and update shadowpos
    useEffect(() => {
        if (holdingItem != '') {
            document.addEventListener('mousemove', mouseMoveActionRef.current);
        } else {
            document.removeEventListener('mousemove', mouseMoveActionRef.current);
        }
    }, [holdingItem]);

    //ui functions
    const OnDeleteSelectedClicked = () => {
        if (
            eventItemRef.current
            && eventItemRef.current.itemID != ''
        ) {
            if (window.confirm("Are you sure to delete the selected items? (This action is not reversible!)")) {
                //removing the selected item files from eventItem
                const _fileNames = eventItemRef.current.file_names;
                selectedImagesIndexRef.current.map((imageIndex: number) => {
                    _fileNames.splice(imageIndex, 1, '');
                });
                const  __fileNames: string[] = [];
                _fileNames.map((fileName: string, i: number) => {
                    if(fileName.replace(/\s/g, '') != '')
                        __fileNames.push(fileName);
                });

                //remove fileNames on server and db
                let formData = new FormData();

                formData.append('s3cr3t', Encryptor.Encrypt(nonstate.s3cr3t));
                formData.append('deleteEventItemFileNames', Encryptor.Encrypt('true'));
                formData.append('itemID', Encryptor.Encrypt(eventItemRef.current.itemID));
                formData.append('newFileNames', Encryptor.Encrypt(__fileNames.join(',')));

                axios.post(nonstate.eventItemControlUrl, formData, { withCredentials: false })
                    .then((res: any) => {
                        // console.log('checkres: ' + JSON.stringify(res.data));
                        const resData = Encryptor.Decrypt(res.data.toString());

                        if (!resData.includes('_false')) {
                            //successfully deleted fileNames, initiate refetch
                            SetShouldRefetchEventItem(true);
                        } else {
                            console.log('deleteEventItemFileNamesErr' + resData);
                        }

                        SetShouldShowWaitScreen(false);
                    }).catch((err: string) => {
                        console.log('deleteEventItemFileNamesErr: ' + err);
                        SetShouldShowWaitScreen(false);
                    });

                selectedImagesIndexRef.current = [];
                SetSelectedImagesIndex([...selectedImagesIndexRef.current]);
                SetShouldShowWaitScreen(true);
            }
        }
    }
    const OnItemSelectDeselect = (index: number) => {
        let itemSelectedIndex = -1; //-1 = itemNotSelected
        selectedImagesIndexRef.current.map((imageIndex: number, i: number) => {
            if (imageIndex == index)
                itemSelectedIndex = i;
        });

        if (itemSelectedIndex != -1) {
            //item already selected, deselect item
            selectedImagesIndexRef.current.splice(itemSelectedIndex, 1);
        } else {
            //item not selected, select item
            selectedImagesIndexRef.current.push(index);
        }

        //update selectedImagesIndexState
        SetSelectedImagesIndex([...selectedImagesIndexRef.current]);
    }
    const OnItemsAdded = (e: any) => {
        if (e.target.files.length > 0 && optionFileSelectorRef.current) {
            const files = e.target.files;
            shouldAddItemCountRef.current = files.length;
            const _files = Array.from(files);

            _files.map((file: any) => {
                const reader = new FileReader();
                reader.onload = function (e2: any) {
                    if (eventItemRef.current && prevSelectedEventRef.current) {
                        const base64 = e2.target.result;
                        const formData = new FormData();
                        formData.append('s3cr3t', Encryptor.Encrypt(nonstate.s3cr3t));
                        formData.append('addNewFile', Encryptor.Encrypt('true'));
                        formData.append('eventID', Encryptor.Encrypt(prevSelectedEventRef.current.eventID));
                        formData.append('base64', 'NOENCRYPT' + base64);

                        axios.post(nonstate.eventItemControlUrl, formData, { withCredentials: false }).then((res: any) => {
                            const resData = Encryptor.Decrypt(res.data.toString());
                            if (!JSON.stringify(resData).includes('_false')) {
                                shouldAddItemCountRef.current -= 1;

                                if (shouldAddItemCountRef.current == 0) {
                                    alert('All items suffessfully added!');
                                    SetShouldRefetchEventItem(true);
                                    SetShouldShowWaitScreen(false);
                                }
                            } else {
                                console.log('addNewItemErr: ' + res.data);
                            }
                        }).catch((err: string) => {
                            console.log('addNewItemErr: ' + err);
                        });
                    };
                }
                reader.readAsDataURL(file);
                optionFileSelectorRef.current.value = '';

                SetShouldShowWaitScreen(true);
            });
        }
    }
    const OnItemHold = (e: any, index: number) => {
        if (eventItemRef.current) {
            e.preventDefault();

            holdingItemRef.current = eventItemRef.current.base_url + eventItemRef.current.file_names[index];
            SetHoldingItem(holdingItemRef.current);
            document.addEventListener('mouseup', mouseUpActionRef.current);
        }
    }
    const OnMouseEnterItem = (index: number) => {
        if (
            holdingItemRef.current != ''
            && GetItemIndex(holdingItemRef.current) != index
        ) {
            attemptToMoveItemToIndexRef.current = index;
            SetAttemptToMoveItemToIndex(attemptToMoveItemToIndexRef.current);
        }
    }
    const OnMouseLeaveItem = (index: number) => {
        if (
            holdingItemRef.current != ''
            && attemptToMoveItemToIndexRef.current == index
        ) {
            attemptToMoveItemToIndexRef.current = null;
            SetAttemptToMoveItemToIndex(null);
        }
    }

    //exe functions
    const MoveItemIndex = (subjectItem: string, newIndex: number) => {
        if (eventItemRef.current) {
            const _subjectItem = subjectItem.replace(eventItemRef.current.base_url, '');
            const _fileNames = eventItemRef.current.file_names;
            //remove subjectitem from the list first
            let foundIndex = -1;
            _fileNames.map((fileName: string, i: number) => {
                if (fileName == _subjectItem)
                    foundIndex = i;
            });
            if (foundIndex != -1) {
                _fileNames.splice(foundIndex, 1);
            } else {
                console.log('MoveItemIndexErr: SubjectItemNotFound!');
            }
            //insert the subjectItem back into the list to new position
            _fileNames.splice(newIndex, 0, _subjectItem);

            const formData = new FormData();
            formData.append('s3cr3t', Encryptor.Encrypt(nonstate.s3cr3t));
            formData.append('rearrangeFileNames', Encryptor.Encrypt('true'));
            formData.append('itemID', Encryptor.Encrypt(eventItemRef.current.itemID));
            formData.append('newFileNames', Encryptor.Encrypt(_fileNames.join(',')));

            axios.post(nonstate.eventItemControlUrl, formData, { withCredentials: false }).then((res: any) => {
                const resData = Encryptor.Decrypt(res.data);

                if (!JSON.stringify(resData).includes('_false')) {
                    alert('Successfully moved an item!');
                    SetShouldRefetchEventItem(true);
                } else {
                    console.log('MoveItemIndexLandscapeErr: ' + res.data);
                }
            }).catch((err: string) => {
                console.log('MoveItemIndexLandscapeErr: ' + err);
            });
        }
    }
    const GetItemIndex = (itemSubject: string) => {
        let res = 0;
        if (eventItemRef.current) {
            eventItemRef.current.file_names.map((fileName: string, i: number) => {
                if (fileName == itemSubject)
                    res = i;
            });
        }
        return res;
    }

    //check functions
    const IsGalleryItemSelected = (index: number) => {
        let res = false;
        selectedImagesIndexRef.current.map((imageIndex: number) => {
            if (index == imageIndex)
                res = true;
        });
        return res;
    }

    return (
        <div className='AdminEventGallery'>
            <div className='search-bar'>
                <SearchIcon />
                <input className='search-in' value={newSearchTerm} onChange={(e: any) => SetNewSearchTerm(e.target.value)} onBlur={(e: any) => SetNewSearchTerm(e.target.value.trim())} placeholder='event name, event id, event descriptions' ref={searchInRef} onFocus={() => SetNewSearchTerm('')} />
                {
                    searchedEventList.length > 0 ?
                        <div className='search-list-scroll'>
                            {
                                searchedEventList.map((event: Event) => {
                                    return (
                                        <button className='event-list-row-btn' onClick={() => SetSelectedEvent(event)}>
                                            {event.event_name}
                                        </button>
                                    );
                                })
                            }
                        </div>
                        :
                        null
                }
            </div>
            <div className='option-panel'>
                <span className='title'>Gallery Items</span>
                {
                    selectedEvent ?
                        <div className='option-btns'>
                            <button className='option-btn selected' onClick={() => OnDeleteSelectedClicked()}><DeleteIcon />Delete Selected ({selectedImagesIndex.length})</button>
                            <label className='option-btn selected' htmlFor="option-file-selector">
                                <AddIcon />
                                Add New Pictures
                            </label>
                            <input id='option-file-selector' ref={optionFileSelectorRef} className='option-in selected' type='file' accept="image/*" onChange={(e: any) => OnItemsAdded(e)} multiple style={{ display: 'none' }} />
                        </div>
                        :
                        null
                }
            </div>
            {
                selectedEvent ?
                    <div className='gallery-item-scroll'>
                        {
                            eventItem
                                && Object.keys(eventItem).length > 0
                                && eventItem.file_names.length > 0 ?
                                eventItem.file_names.map((fileName: string, i: number) => {
                                    return (
                                        <button className={'gallery-item-btn ' + (IsGalleryItemSelected(i) ? 'selected' : '') + (attemptToMoveItemToIndex == i ? ' sort-before' : '')}
                                            onClick={() => OnItemSelectDeselect(i)}
                                            onMouseDown={(e: any) => OnItemHold(e, i)}
                                            onMouseEnter={() => OnMouseEnterItem(i)}
                                            onMouseLeave={() => OnMouseLeaveItem(i)}
                                        >
                                            <img className='gallery-item-img' src={eventItem.base_url + fileName} />
                                        </button>
                                    )
                                })
                                :
                                <span className='no-event-selected-lbl'>No Image Found<br />Add Some New Pictures.</span>
                        }
                        <img ref={holdingItemContainerRef} className={'holding-item ' + (holdingItem != '' ? 'show' : 'hide')} src={holdingItem} style={{ left: shadowPos.x, top: shadowPos.y }} />
                    </div>
                    :
                    <span className='no-event-selected-lbl'>No Event Selected<br />Search and select an event from search bar.</span>
            }
            {
                shouldShowWaitScreen?
                <span className='wait-screen'>please wait ...</span>
                :
                null
            }
        </div>
    );
};
export default AdminEventGallery;